/*
  Ischia SPAEH - Barra "Aggiungi al carrello" sempre visibile su mobile.

  Comportamento nativo del tema BeYours: il custom element <animate-sticky>
  (assets/global.js) rivela la barra solo quando lo scroll supera l'offsetTop
  dell'elemento, che nel markup sta in fondo a sections/main-product.liquid.
  Su mobile la barra comparirebbe quindi solo dopo descrizione e accordion,
  molto oltre il punto in cui serve.

  Qui la barra resta visibile dall'apertura della pagina. Non si forza il CSS:
  si tiene acceso l'attributo 'animate' che il tema usa gia' per rivelarla, cosi'
  restano valide tutte le regole native che la nascondono quando si apre il
  carrello, il menu o la ricerca. Quelle regole guardano le classi sul body, non
  questo attributo, quindi continuano a vincere.

  Su desktop non cambia nulla: l'osservatore parte solo sotto i 750px.
*/
(function () {
  var MOBILE_QUERY = '(max-width: 749px)';
  var PINNED_CLASS = 'wg-sticky-atc-pinned';
  var HEIGHT_PROPERTY = '--wg-sticky-atc-height';

  function setup(root) {
    var scope = root || document;
    var wrapper = scope.querySelector('animate-sticky.sticky-cart-wrapper');
    if (!wrapper || wrapper.dataset.wgStickyAtc === 'on') return;

    var bar = wrapper.querySelector('.product-sticky-cart');
    if (!bar || typeof MutationObserver === 'undefined') return;

    wrapper.dataset.wgStickyAtc = 'on';

    var mql = window.matchMedia(MOBILE_QUERY);
    var observer = null;

    /* La barra copre il fondo della pagina: si misura per liberare altrettanto
       spazio sotto il contenuto, altrimenti l'ultima riga resta nascosta. */
    function measure() {
      var height = bar.offsetHeight;
      if (height > 0) {
        document.documentElement.style.setProperty(HEIGHT_PROPERTY, height + 'px');
      }
    }

    function pin() {
      if (!wrapper.hasAttribute('animate')) wrapper.setAttribute('animate', '');
    }

    function start() {
      if (observer) return;
      pin();
      measure();
      document.documentElement.classList.add(PINNED_CLASS);

      /* Il codice nativo toglie l'attributo a ogni scroll sopra la soglia:
         lo si rimette appena sparisce, invece di riscrivere quella logica. */
      observer = new MutationObserver(pin);
      observer.observe(wrapper, { attributes: true, attributeFilter: ['animate'] });

      window.addEventListener('resize', measure);
    }

    function stop() {
      if (!observer) return;
      observer.disconnect();
      observer = null;
      window.removeEventListener('resize', measure);
      document.documentElement.classList.remove(PINNED_CLASS);
      document.documentElement.style.removeProperty(HEIGHT_PROPERTY);
      /* Si restituisce il comando al tema, che ricalcola alla prima occasione. */
      wrapper.removeAttribute('animate');
      window.dispatchEvent(new Event('scroll'));
    }

    function apply(matches) {
      if (matches) start();
      else stop();
    }

    apply(mql.matches);

    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', function (event) {
        apply(event.matches);
      });
    } else if (typeof mql.addListener === 'function') {
      mql.addListener(function (event) {
        apply(event.matches);
      });
    }
  }

  function init() {
    setup(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Editor del tema: la sezione prodotto viene ricaricata via AJAX. */
  document.addEventListener('shopify:section:load', function (event) {
    setup(event.target);
  });
})();
